<template>
  <v-app>
      <v-app-bar app dark>
        <v-app-bar-nav-icon @click.stop='sideNav = !sideNav' class='hidden-sm-and-up'></v-app-bar-nav-icon>
        <v-toolbar-title>
            <router-link to='/' tag='span' style='cursor: pointer'>
              <img src="@/assets/logo.png" alt="DivorceAnswered.com.au">
              <span class="caption">{{version}}</span>
            </router-link>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items class='hidden-xs-only'>
            <v-btn
            text
            v-for='item in menuItems'
            :key='item.title'
            :to='item.link'>
            <v-icon left v-if='item.icon'>{{ item.icon }}</v-icon>
            {{ item.title }}
            </v-btn>
        </v-toolbar-items>
      </v-app-bar>
      <v-content>
        <router-view></router-view>
      </v-content>
      <app-footer></app-footer>
  </v-app>
</template>

<script>
export default {
  data: () => ({
    sideNav: false,
    version: process.env.VUE_APP_VERSION
  }),
  computed: {
    menuItems () {
      const menuItems = [
        { title: 'Register', link: '/register' },
        { title: 'Login', link: '/login' }
      ]
      return menuItems
    }
  },
  methods: {}
}
</script>
